import ProfilePicture from "@/components/common/profile-picture";
import Modal from "@/components/ui/modal";
import useClipboard from "@/hooks/useClipboard";
import CongratulationsIcon from "@/icons/congratulations";
import { CopyIcon } from "lucide-react";
import Link from "next/link";

type TCongratulationsModalProps = {
	username: string;
	isVIP?: boolean;
	profileImage?: string;
	isOpen: boolean;
	onClose: () => void;
	link?: string;
	linkText?: string;
};

const CongratulationsModal = ({
	username,
	isVIP = false,
	profileImage,
	isOpen,
	onClose,
	link,
	linkText,
}: TCongratulationsModalProps) => {
	const { isCopied, handleCopy } = useClipboard();

	return (
		<Modal isOpen={isOpen} onClose={onClose} className="max-w-md px-8 py-6 text-center">
			{isVIP && profileImage ? (
				<ProfilePicture
					profilePictureUrl={profileImage}
					alternateText={username}
					className={{
						container: "mx-auto mb-8 h-32 w-32 rounded-full",
						image: "rounded-full fill-gray-500",
					}}
					isVerified={true}
					isFounder={isVIP}
				/>
			) : (
				<CongratulationsIcon className="mx-auto h-24 w-24" />
			)}

			{isVIP ? (
				<div>
					<h3 className="mt-6 text-xl font-semibold">
						Congratulations! You Are a{" "}
						<span className="font-semibold text-brand-primary underline">VIP</span> Now!
					</h3>
					<p className="mt-2 text-gray-500">You have earned a VIP Badge</p>

					<div className="mt-6 rounded-lg border bg-gray-50 p-3">
						<div className="flex items-center justify-start rounded-lg border">
							<h5 className="whitespace-nowrap p-2 text-xs font-semibold">Your Profile</h5>
							<div className="relative flex w-full items-center justify-between bg-brand-primary/5 p-2">
								<span className="w-20 truncate text-xs italic text-brand-primary md:w-auto">
									{`www.proptechbuzz.com/${username}`}
								</span>

								<button
									type="button"
									className="rounded-lg border bg-white p-2"
									onClick={() => handleCopy(`www.proptechbuzz.com/${username}`)}
								>
									<CopyIcon className="h-4 w-4 text-brand-primary" />
								</button>

								{isCopied ? (
									<div className="absolute -right-2 -top-5 rounded-lg border bg-white px-3 py-1 text-xs font-medium">
										Copied
									</div>
								) : null}
							</div>
						</div>
					</div>
				</div>
			) : (
				<>
					<h3 className="mt-6 text-2xl font-semibold">Congratulations</h3>
					<p className="mt-3 text-gray-600">You are verified and earned a Buzzing Bee badge</p>

					<Link
						href={link ? link : `/${username}`}
						className="mt-6 block w-full rounded-md bg-brand-primary py-3 text-xl font-semibold text-white"
					>
						{linkText ? linkText : "View your profile"}
					</Link>
				</>
			)}
		</Modal>
	);
};

export default CongratulationsModal;
